import { useState } from "react";
import "./appq.css";
import { useEffect } from 'react';
import FormInput from "./components/FormInput.js";
import { useSearchParams, useNavigate, NavLink } from "react-router-dom";
import { db } from "./firebase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { serverTimestamp } from "firebase/firestore";

const Formtopup = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const [searchparams] = useSearchParams();
  const carrier = searchparams.get("carrier");
  const navigate = useNavigate();
  const [amount, setAmount] = useState("$10");
  const [values, setValues] = useState({
    name: "",
    phonenumber: "",
  });

  const inputs = [
    {
      id: 1,
      name: "name",
      type: "text",
      placeholder: "Name",
      errorMessage: "Please fill in your name",
      label: "Name",
      required: true,
    },
    {
      id: 2,
      name: "phonenumber",
      type: "String",
      placeholder: "Phone Number",
      errorMessage: "Please fill in the correct 10-digit phone number",
      label: "Phone Number",
      pattern: "^[0-9]{10,10}$",
      required: true,
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    db.collection("topup")
      .add({
        Name: values.name,
        phonenumber: values.phonenumber,
        carrier: carrier,
        amount: amount,
        done: "no",
        time: serverTimestamp(),
      })
      .then((docRef) => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
    console.log(amount);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  const handleChangedrop = (event) => {
    setAmount(event.target.value);
  };

  return (
    <div className="app" style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <NavLink to="/topup">
          <FontAwesomeIcon
            style={{
              position: "absolute",
              marginLeft: 10,
              marginTop: 25,
              color: "#663399",
            }}
            icon={faArrowLeft}
            className="fa-2xl"
          />
        </NavLink>
        <div style={{ width: "100%" }}>
          <h1 style={{ justifySelf: "center" }}>{carrier} Topup</h1>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        {inputs.map((input) => (
          <FormInput
            key={input.id}
            {...input}
            value={values[input.name]}
            onChange={onChange}
          />
        ))}
        <label
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Topup Amount
          <select
            value={amount}
            onChange={handleChangedrop}
            style={{
              padding: "15px",
              width: "160px",
              margin: "10px 0px",
              borderRadius: "5px",
              border: "1px solid gray",
            }}
          >
            <option value="$10">$10</option>
            <option value="$25">$25</option>
            <option value="$35">$35</option>
            <option value="$40">$40</option>
            <option value="$45">$45</option>
            <option value="$50">$50</option>
            <option value="$60">$60</option>
            <option value="$70">$70</option>
          </select>
        </label>
        <button>Submit</button>
      </form>
    </div>
  );
};

export default Formtopup;
